// extracted by mini-css-extract-plugin
var _1 = "WarningBanner_faExclamationCircle__fZzy0";
var _2 = "WarningBanner_icon__D8nLq";
var _3 = "WarningBanner_message__rGxSs";
var _4 = "WarningBanner_subtitle__ZZm1q";
var _5 = "WarningBanner_title__dNfb2";
var _6 = "WarningBanner_wbContainer__flx0T";
export { _1 as "faExclamationCircle", _2 as "icon", _3 as "message", _4 as "subtitle", _5 as "title", _6 as "wbContainer" }
